import {
  Person,
  PersonOutline,
  Settings,
  SettingsOutlined,
  Bookmark,
  BookmarkBorderOutlined,
  FavoriteBorderOutlined,
  FavoriteOutlined,
  NotificationsNone,
  Notifications,
} from "@material-ui/icons";
import {
  RiArticleFill,
  RiArticleLine,
  RiBook3Fill,
  RiBook3Line,
} from "react-icons/ri";
const tabs = [
  {
    name: "Profile",
    panel: 0,
    icon: <PersonOutline />,
    activeIcon: <Person />,
  },
  {
    name: "Orders",
    panel: 1,
    icon: <BookmarkBorderOutlined />,
    activeIcon: <Bookmark />,
  },
  {
    name: "Wishlist",
    panel: 2,
    icon: <FavoriteBorderOutlined />,
    activeIcon: <FavoriteOutlined />,
  },
  {
    name: "Books",
    panel: 4,
    icon: <RiBook3Line />,
    activeIcon: <RiBook3Fill />,
  },
  {
    name: "KleverBooks",
    panel: 8,
    icon: <RiBook3Line />,
    activeIcon: <RiBook3Fill />,
  },
  {
    name: "Articles",
    panel: 7,
    icon: <RiArticleLine />,
    activeIcon: <RiArticleFill />,
  },
  {
    name: "Notifications",
    panel: 5,
    icon: <NotificationsNone />,
    activeIcon: <Notifications />,
  },
  {
    name: "Settings",
    panel: 3,
    icon: <SettingsOutlined />,
    activeIcon: <Settings />,
  },
];

export default tabs;
